import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import LoadingButton from "@mui/lab/LoadingButton";
import Check from "@mui/icons-material/Check";

import { useGetDataMutation } from "../../../../api/forms.api.slice";
import { showNotification } from "../../../../features/core/slices/notification.slice";
import {
  constructSearchUrl,
  formRecordSelectionReq as getParams,
} from "../../services/form.service";
import { notifyError } from "../../../../utils/helpers";
import { requireFieldsInfo } from "../../context/formSlice";

function VerifyAndUpdateBtn(props) {
  const {
    fieldProps,
    setValue,
    getValues,
    trigger,
    disabled,
    datagridFormState,
  } = props;
  const dispatch = useDispatch();
  const [getData, { isLoading }] = useGetDataMutation();

  const { tags, label, properties = {} } = fieldProps;
  const {
    url,
    methodPost,
    queryParamKeys,
    updateKeys = "",
    autoFetchOnLoad,
    resultValue = "Y",
  } = properties;

  const verifyToggleBtnKey = `${fieldProps.key}Verified`;

  const onBtnClick = async () => {
    const requiredFields = datagridFormState
      ? requireFieldsInfo.requiredFields[datagridFormState.datagridKey]
      : requireFieldsInfo.requiredFields;

    const verifyToggleBtnIsPresent =
      verifyToggleBtnKey in requiredFields || verifyToggleBtnKey in getValues(); // NOTE: temp fix

    if (tags && tags.length && url) {
      const isValid = await trigger(tags);
      const shouldValidate = { shouldValidate: true };
      if (isValid) {
        const searchUri = constructSearchUrl(url, getValues());
        const params = getParams({ queryParamKeys }, getValues());
        const payload = { url: searchUri };
        if (methodPost) {
          payload.body = { data: {} };
          Object.entries(params).forEach(([key, value]) => {
            if (key.startsWith("data."))
              payload.body.data[key.split("data.")[1]] = value;
            else payload.body[key] = value;
          });
        } else payload.params = params;
        try {
          const response = await getData(payload).unwrap();
          if (response.isValid?.toString() === resultValue?.toString()) {
            updateKeys.split(",").forEach((key) => {
              let sourceKey = key;
              if (properties[sourceKey])
                sourceKey = properties[sourceKey].substring(1);
              if (sourceKey in response) setValue(key, response[sourceKey]);
            });
            if (verifyToggleBtnIsPresent)
              setValue(verifyToggleBtnKey, true, shouldValidate);
          } else {
            if (verifyToggleBtnIsPresent)
              setValue(verifyToggleBtnKey, false, shouldValidate);
            notifyError(dispatch, showNotification, {
              data: { message: response.message },
            });
          }
        } catch (err) {
          if (verifyToggleBtnIsPresent)
            setValue(verifyToggleBtnKey, false, shouldValidate);
          notifyError(dispatch, showNotification, err);
        }
      } else {
        const msg = "Please fill the required fields.";
        dispatch(showNotification({ type: "warning", msg, show: true }));
      }
    }
  };

  useEffect(() => {
    const hasVerified = getValues(verifyToggleBtnKey);
    if (hasVerified && autoFetchOnLoad) onBtnClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoadingButton
      variant="contained"
      onClick={onBtnClick}
      startIcon={<Check />}
      disabled={disabled}
      loading={isLoading}
      loadingPosition="start"
    >
      {label}
    </LoadingButton>
  );
}
VerifyAndUpdateBtn.propTypes = {
  fieldProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  setValue: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  trigger: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default VerifyAndUpdateBtn;
